import { useEffect, useState } from 'react';

// The 1024px desktop breakpoint shared by the receptor portal and the
// platform WhatsApp view; keep in step with the min-width: 1024px CSS.
export const DESKTOP_QUERY = '(min-width: 1024px)';

function read(query) {
  if (typeof window === 'undefined') return false;
  return window.matchMedia?.(query)?.matches ?? false;
}

// Tracks a CSS media query. Without matchMedia (old browsers, some test
// environments) it reports false, the same fallback the receptor workspace uses.
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => read(query));
  useEffect(() => {
    const media =
      typeof window === 'undefined' ? null : window.matchMedia?.(query);
    if (!media) return undefined;
    const change = () => setMatches(media.matches);
    change();
    if (media.addEventListener) {
      media.addEventListener('change', change);
      return () => media.removeEventListener('change', change);
    }
    media.addListener?.(change);
    return () => media.removeListener?.(change);
  }, [query]);
  return matches;
}
